
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","width":"429","height":"286","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M-286.381 366.948L99.145-178.787a31.753 31.753 0 0155.792 7.532l33.415 92.41 133.654-128.778a31.771 31.771 0 0129.227-8.062 31.785 31.785 0 0122.665 20.138l52.455 145.063a31.75 31.75 0 01-7.659 33.495L149.137 246.728a31.781 31.781 0 01-29.278 8.259 31.756 31.756 0 01-22.787-20.159l-33.925-93.82-302.542 268.025c-12.069 10.697-30.233 10.639-42.242-.109a31.717 31.717 0 01-8.67-12.834c-3.43-9.487-2.262-20.393 3.919-29.139l.007-.003z"}})])
          )
        }
      }
    